<template>
  <section class='section'>
    <!-- Table -->
    <table-ag :rowData='relations' :columnDefs='columns' :components='components' :component-menu='componentMenu' :actions='true'></table-ag>
  </section>
</template>
<script>
import apiServices from "@/services/yungol-services";
import tableAg from '../dashboard/tableAg.vue'
import buttonsActionSummary from './components/buttonsActionSummary.vue'
import menuTableSummary from './components/menuTableSummary.vue'

export default {
  data(){
    return {
      relations:[],
      columns:[
        {
          field: 'evaluado',
          headerName:'Evaluado',
          autoHeight: true,
          valueGetter: (params) => {return `${params.data[params.colDef.field].nombre} ${params.data[params.colDef.field].email}`},
          getQuickFilterText: (params) => {return `${params.data[params.colDef.field].nombre} ${params.data[params.colDef.field].email}`},
          cellRenderer: (params) => {
            return `<div style='font-size: 1.25rem; font-weight: 550; color: #363636; line-height: 1.125; overflow: hidden; text-overflow: ellipsis; padding-top: 10px'>${ params.data[params.colDef.field].nombre }</div><div style='font-size: 1rem; font-weight: 300; color: #4a4a4a; line-height: 1.25; overflow: hidden; text-overflow: ellipsis; padding-bottom: 10px'>${ params.data[params.colDef.field].email }</div>`
          },
          editable: false
        },
        {
          field: 'cantEncuestas',
          headerName: 'Colaboradores',
          width: 50,
          valueGetter: (params) => {return `${params.data['cantEncuestasCalculate']} / ${params.data[params.colDef.field]}`},
          cellStyle: {
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            'padding-right': '5'
          },
          editable: false,
        },
        {
          field: 'status',
          headerName:'Estado',
          width: 50,
          cellRenderer: params => {return this.formatStatus(params.value)},
          cellStyle: {
            textAlign: 'center',
            justifyContent: 'center',
            alignItems: 'center',
            'padding-right': '5'
          },
          editable: false,
        },
        {
          field: '_id',
          headerName:'Controles',
          colId: '_actions',
          editable: false,
          cellRenderer: 'ButtonsActionSummary',
          sortable: false,
          width: 60,
        }
      ],
      components: {
        ButtonsActionSummary: () =>{
          return {
            render: h => h(buttonsActionSummary,{
              props:{
              }
            })
          }
        }
      },
      componentMenu: () =>{
        return {
          render: h => h(menuTableSummary,{
            props:{
              proceso: this.proceso
            }
          })
        }
      }
    }
  },
  props:{
    proceso: {
      type: Object,
    },
    tokenUser:{
      type: Object,
    }
  },
  beforeMount(){
    this.$emit('calculateProcess')
  },
  methods:{
    // Table
    async getRelations(){
      try {
        const result = await apiServices.get(
            `/listliderrelacionauto/${this.proceso._id}`
        );
        if (result.data) {
          this.relations = result.data
        }
      } catch (err) {
        await this.$store.dispatch("notify", {
          message: "Error al obtener las relaciones.",
          type: "is-danger",
          duration: 4000,
          position: "top-right",
        });
        console.log(err);
      }
    },
    // Helpers
    formatStatus(v){
      v = v.toLowerCase()

      if (v === "creado"){
        return `<span class="tag is-grey is-capitalized">${v}</span>`
      }
      if (v === "enviado"){
        return `<span class="tag is-warning is-capitalized">${v}</span>`
      }
      if (v === "terminado"){
        return `<span class="tag is-link is-capitalized">${v}</span>`
      }
      if (v === 'calculado'){
        return `<span class="tag is-success is-capitalized">${v}</span>`
      }
    },
  },
  created() {
    this.getRelations()
  },
  components:{
    tableAg
  }
}
</script>



// WEBPACK FOOTER //
// src/components/lideres/Resumen.vue